// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2gxR9","fileDisabled":"File_fileDisabled__IoqhG"};